module.exports = __webpack_public_path__ + "static/media/ProfileIconBorder.79bfcfb6.svg";